module.exports = __webpack_public_path__ + "img/ddsc.41975719.png";